

















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Navbar extends Vue {
  private items = [
    { text: '主页', path: '/home' },
    { text: '项目介绍', path: '/projects' },
    { text: 'MOOC', path: '/mooc' },
    { text: '关于我们', path: '/contact' },
  ];
}
